import * as types from './mutation-types'

const state = {
  managedPages: {
    data: [],
  },
  managedPage: {
    attributes: {
      title: '',
    },
  },
}

const mutations = {
  [types.MANAGED_PAGE_SET_MANAGED_PAGE](state, Page) {
    state.managedPage = Page
  },
  [types.MANAGED_PAGE_SET_MANAGED_PAGES](state, ManagedPages) {
    state.managedPages = ManagedPages
  },
}

export default {
  state,
  mutations,
}